import styled from "styled-components";
import Container from "@mui/material/Container";

export const StyledContainer = styled(Container)``;
